import React from 'react';
import { Link } from 'react-router-dom';
import logoImg from '../../assets/logo-256.png';
import { useLanguage } from '../../context/LanguageContext';

const Footer = () => {
  const { t } = useLanguage();
  const year = new Date().getFullYear();

  return (
    <footer style={{ background: '#064E3B', color: 'rgba(255,255,255,0.8)', padding: '3rem 0 1.5rem' }}>
      <div className="container">
        <div className="row g-4 mb-4">
          {/* Brand */}
          <div className="col-lg-4 col-md-6">
            <Link to="/" className="d-flex align-items-center text-decoration-none mb-3">
              <img src={logoImg} alt="FarmDirectly" style={{ height: '60px', width: 'auto' }} />
            </Link>
            <p style={{ fontSize: '0.9rem', lineHeight: 1.7, maxWidth: '320px' }}>
              Connecting farmers directly with wholesale sellers, retailers and individual buyers. Fresh dairy, vegetables, fruits, flowers & food products delivered to your doorstep.
            </p>
          </div>

          {/* Shop */}
          <div className="col-6 col-md-3 col-lg-2">
            <h6 className="fw-bold mb-3" style={{ color: '#EAB308' }}>Shop</h6>
            <ul className="list-unstyled" style={{ fontSize: '0.9rem' }}>
              <li className="mb-2"><Link to="/products?category=dairy" style={{ color: 'inherit', textDecoration: 'none' }}>Dairy Products</Link></li>
              <li className="mb-2"><Link to="/products?category=vegetables" style={{ color: 'inherit', textDecoration: 'none' }}>Fresh Vegetables</Link></li>
              <li className="mb-2"><Link to="/products?category=fruits" style={{ color: 'inherit', textDecoration: 'none' }}>Fresh Fruits</Link></li>
              <li className="mb-2"><Link to="/products?category=flowers" style={{ color: 'inherit', textDecoration: 'none' }}>Flowers & Garlands</Link></li>
              <li className="mb-2"><Link to="/products?category=food_products" style={{ color: 'inherit', textDecoration: 'none' }}>Food Products</Link></li>
            </ul>
          </div>

          {/* For Farmers */}
          <div className="col-6 col-md-3 col-lg-2">
            <h6 className="fw-bold mb-3" style={{ color: '#EAB308' }}>For Farmers</h6>
            <ul className="list-unstyled" style={{ fontSize: '0.9rem' }}>
              <li className="mb-2"><Link to="/register?role=farmer" style={{ color: 'inherit', textDecoration: 'none' }}>Start Selling</Link></li>
              <li className="mb-2"><Link to="/farmer/dashboard" style={{ color: 'inherit', textDecoration: 'none' }}>Farmer Dashboard</Link></li>
              <li className="mb-2"><Link to="/faq" style={{ color: 'inherit', textDecoration: 'none' }}>How It Works</Link></li>
              <li className="mb-2"><Link to="/help" style={{ color: 'inherit', textDecoration: 'none' }}>Farmer Support</Link></li>
            </ul>
          </div>

          {/* Company */}
          <div className="col-6 col-md-3 col-lg-2">
            <h6 className="fw-bold mb-3" style={{ color: '#EAB308' }}>Company</h6>
            <ul className="list-unstyled" style={{ fontSize: '0.9rem' }}>
              <li className="mb-2"><Link to="/about" style={{ color: 'inherit', textDecoration: 'none' }}>About Us</Link></li>
              <li className="mb-2"><Link to="/contact" style={{ color: 'inherit', textDecoration: 'none' }}>Contact</Link></li>
              <li className="mb-2"><Link to="/terms" style={{ color: 'inherit', textDecoration: 'none' }}>Terms</Link></li>
              <li className="mb-2"><Link to="/privacy" style={{ color: 'inherit', textDecoration: 'none' }}>Privacy</Link></li>
            </ul>
          </div>

          {/* Buyer Types */}
          <div className="col-6 col-md-3 col-lg-2">
            <h6 className="fw-bold mb-3" style={{ color: '#EAB308' }}>For Buyers</h6>
            <ul className="list-unstyled" style={{ fontSize: '0.9rem' }}>
              <li className="mb-2"><Link to="/register?role=individual_buyer" style={{ color: 'inherit', textDecoration: 'none' }}>Individual Buyers</Link></li>
              <li className="mb-2"><Link to="/register?role=retailer" style={{ color: 'inherit', textDecoration: 'none' }}>Retailers</Link></li>
              <li className="mb-2"><Link to="/register?role=wholesale_buyer" style={{ color: 'inherit', textDecoration: 'none' }}>Wholesale Buyers</Link></li>
            </ul>
          </div>
        </div>

        <hr style={{ borderColor: 'rgba(255,255,255,0.15)' }} />

        <div className="d-flex flex-column flex-md-row justify-content-between align-items-center" style={{ fontSize: '0.85rem' }}>
          <p className="mb-0">© {year} FarmDirectly. Empowering farmers, feeding communities.</p>
          <p className="mb-0 mt-2 mt-md-0">🌾 From Soil to Doorstep | Fair. Fresh. Direct.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
